import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IMessageHeaderProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    MessagePartContentProps
} from "../../type";
import {
    MESSAGE_PLAIN_AVATAR_SIZE
} from "../../stylesheet";
import {
    withMessageContext
} from "../../context";
import Avatar from "../../../avatar";
import Badge from "../../../badge";
import MessageTime from "../time";
import Text from "../../../text";

const MessageHeaderContent: FC<MessagePartContentProps<IMessageHeaderProps>> = ({
    isTimeVisible = true,
    customLocalize,
    customTheme,
    context,
    badge,
    style,
    ...props
}) => {
    const currentTheme = customTheme ?? context.customTheme;

    const {
        controlPaddings,
        spaces
    } = NCoreUIKitTheme.useContext(currentTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        isPlain: context.isPlain,
        controlPaddings,
        spaces
    });

    const isHeaderAllowed = context.align === "start" && !context.isSystem && (context.groupPosition === "first" || context.groupPosition === "single");

    const isAvatarShown = context.isPlain && Boolean(context.avatar);

    const isTimeShown = isTimeVisible && Boolean(context.timestamp);

    if(!isHeaderAllowed || (!isAvatarShown && !context.title && !badge && !isTimeShown)) {
        return null;
    }

    const renderAvatar = () => {
        if(!isAvatarShown) {
            return null;
        }

        return <Avatar
            customLocalize={context.customLocalize}
            size={MESSAGE_PLAIN_AVATAR_SIZE}
            customTheme={currentTheme}
            title={context.title}
            {...context.avatar}
        />;
    };

    const renderName = () => {
        if(!context.title) {
            return null;
        }

        return <Text
            customTheme={currentTheme}
            variant="labelSmallSize"
            style={stylesheet.name}
            numberOfLines={1}
            color="mid"
        >
            {context.title}
        </Text>;
    };

    const renderBadge = () => {
        if(!badge) {
            return null;
        }

        return <Badge
            customTheme={currentTheme}
            type="neutral"
            title={badge}
            size="small"
        />;
    };

    const renderTime = () => {
        if(!isTimeShown || !context.timestamp) {
            return null;
        }

        return <MessageTime
            customLocalize={customLocalize ?? context.customLocalize}
            timestamp={context.timestamp}
            customTheme={currentTheme}
        />;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {renderAvatar()}
        {renderName()}
        {renderBadge()}
        {renderTime()}
    </View>;
};

const MessageHeader = withMessageContext<IMessageHeaderProps>("Header", MessageHeaderContent);
export default MessageHeader;
